import styles from './Toast.module.css';

export function Toast({ message }: { message: string }) {
  if (!message) return null;
  return (
    <div className={styles.toast} role="status" aria-live="polite">
      <span className={styles.dot} />
      <span className={styles.message}>{message}</span>
    </div>
  );
}
